import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { integrationService } from '@/services'

export const useIntegrationsStore = defineStore('integrations', () => {
  const astroLoaded = ref(false)
  const astroEnabled = ref(false)
  const astroConfig = ref({})
  const astroHasSecrets = ref(false)

  let astroFetchInflight = null

  const getAstroEnabled = computed(() => astroEnabled.value)
  const getAstroConfig = computed(() => astroConfig.value || {})
  const getAstroHasSecrets = computed(() => astroHasSecrets.value)
  const isAstroLoaded = computed(() => astroLoaded.value)

  const loadAstroConfig = async ({ force = false } = {}) => {
    if (!force && astroLoaded.value) {
      return {
        enabled: astroEnabled.value,
        config: astroConfig.value,
        has_secrets: astroHasSecrets.value
      }
    }

    if (!force && astroFetchInflight) return astroFetchInflight

    astroFetchInflight = (async () => {
      try {
        const { data } = await integrationService.getAstroConfig()
        astroEnabled.value = !!data?.enabled
        astroConfig.value = data?.config || {}
        astroHasSecrets.value = !!data?.has_secrets
      } catch {
        // If the caller doesn't have settings permissions or request fails,
        // default to disabled so we don't attempt Astro calls.
        astroEnabled.value = false
        astroConfig.value = {}
        astroHasSecrets.value = false
      } finally {
        astroLoaded.value = true
        astroFetchInflight = null
      }

      return {
        enabled: astroEnabled.value,
        config: astroConfig.value,
        has_secrets: astroHasSecrets.value
      }
    })()

    return astroFetchInflight
  }

  const ensureAstroEnabled = async () => {
    if (!astroLoaded.value) {
      await loadAstroConfig()
    }
    return astroEnabled.value
  }

  return {
    // state
    astroLoaded,
    astroEnabled,
    astroConfig,
    astroHasSecrets,

    // getters
    getAstroEnabled,
    getAstroConfig,
    getAstroHasSecrets,
    isAstroLoaded,

    // actions
    loadAstroConfig,
    ensureAstroEnabled
  }
})

